import type { FC } from "react"

import type { Point2d } from "@logic/lib/2d"
import { atom, useRecoilTransaction_UNSTABLE, useRecoilValue } from "recoil"

import type { TransactionOperation } from "~/containers/LegacyDesigner/state/elements/transactions"

import { nextPlaybackStep, prevPlaybackStep } from "../visualizeSteps"
import { RainbowFacesPlayback } from "../Visuals/RainbowFacesPlayback"

export const tracingNodesState = atom<Point2d[][]>({
  key: `tracingNodes`,
  default: [[]],
})

export const tracingFacesState = atom<Point2d[][]>({
  key: `tracingFaces`,
  default: [],
})

export const tracingPlaybackState = atom<[number, number]>({
  key: `tracingNodesPlayback`,
  default: [0, 0],
})

export const getTracingNodes: TransactionOperation<undefined, Point2d[][]> = ({
  get,
}) => get(tracingNodesState)

export const nextTracingStep: TransactionOperation = (transactors) =>
  nextPlaybackStep(transactors, {
    getItems: getTracingNodes,
    playbackState: tracingPlaybackState,
  })

export const prevTracingStep: TransactionOperation = (transactors) =>
  prevPlaybackStep(transactors, {
    getItems: getTracingNodes,
    playbackState: tracingPlaybackState,
  })

export const useTracingStepNavigation = (): [
  prev: () => void,
  next: () => void,
] => [
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => prevTracingStep(transactors),
  ),
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => nextTracingStep(transactors),
  ),
]
